import React from 'react';
import PropTypes from 'prop-types';

const TextArea = props => {
  const {label, type, placeholder, id, name, className, isRequired, isDisabled, textarea, ...rest} = props
  return (
    <div className={`form-item ${className}`}>
      <textarea
        className={`textarea ${textarea.className}`}
        disabled={isDisabled}
        required={isRequired}
        id={id}
        placeholder={placeholder}
        name={name}
        {...rest}
      ></textarea>
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  );
};

TextArea.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  textarea: PropTypes.shape({
    className: PropTypes.string,
  }),
};

TextArea.defaultProps = {
  type: 'text',
  placeholder: '',
  id: '',
  className: '',
  isRequired: false,
  isDisabled: false,
  textarea: {
    className: '',
  },
}

export default TextArea;
